import React from 'react';
import { Helmet } from 'react-helmet';
import { clinicInfo } from '../data/servicesData';

const SchemaMarkup = ({ pageData }) => {
  const medicalBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'Dentist',
    name: clinicInfo.name,
    image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800',
    telephone: clinicInfo.phone,
    email: clinicInfo.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '11/5, Albertponnuswamy street, Bharat Mata Road, Gandhi Nagar',
      addressLocality: 'East Tambaram',
      addressRegion: 'Tamil Nadu',
      postalCode: '600059',
      addressCountry: 'IN'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '12.9249',
      longitude: '80.1000'
    },
    url: window.location.origin,
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '21:00'
      }
    ],
    priceRange: '$$',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: clinicInfo.rating,
      reviewCount: '150'
    }
  };

  const faqSchema = pageData?.faqs ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: pageData.faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  } : null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(medicalBusinessSchema)}
      </script>
      {faqSchema && (
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default SchemaMarkup;
